import axios from 'axios';

const api = axios.create({
	baseURL: `https://producao2.theos.com.br/EclesialEmail/api/v1/EclesialEmail`,
});

export default api;
